import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["disabled", "multiSchema", "selected"];
import React, { memo } from 'react';
import GroupSection from "./GroupSection";
const OptionGroups = /*#__PURE__*/memo(_ref => {
  let {
      disabled,
      multiSchema,
      selected
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return multiSchema.reduce((arr, item) => {
    var _disabled$item$id;
    const disabledArr = (disabled === null || disabled === void 0 ? void 0 : (_disabled$item$id = disabled[item.id]) === null || _disabled$item$id === void 0 ? void 0 : _disabled$item$id.options) || [];
    const id = item.id;
    const selectedObj = selected[id] || {};
    const isSelected = selectedObj.overrideIsSelected || selectedObj.isSelected;
    if (!isSelected) return arr;
    arr.push(/*#__PURE__*/React.createElement(GroupSection, _extends({
      disabled: disabledArr,
      item: item,
      key: id,
      selected: selectedObj
    }, otherProps)));
    return arr;
  }, []);
});
export default OptionGroups;